import React, { useContext } from 'react';
import { PaymentContext, PaymentInfoContext } from '../../App';
import { Checkbox, FormControlLabel, Link } from '@material-ui/core';
import clsx from 'clsx';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';

const Agreement = ({ formik }) => {
  const payment = useContext(PaymentContext);
  const paymentInfo = useContext(PaymentInfoContext);
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    !payment && (
      <div className="agreeCheckbox">
        <FormControlLabel
          control={
            <Checkbox
              onChange={formik.handleChange}
              name="agree"
              color="primary"
              value={formik.values.agree}
              checked={formik.values.agree}
              checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
              icon={<span className={classes.icon} />}
            />
          }
          label={
            <span className={`${formik.values.agree ? classes.checked : null} accept_terms`}>
              {t('I_have_read')}{' '}
              <Link
                underline="always"
                href={paymentInfo?.termsAndConditions}
                rel="noreferrer noopener"
                target="_blank"
                className={formik.values.agree ? classes.checked : null}>
                {t('term_conditions')}
              </Link>{' '}
            </span>
          }
        />
      </div>
    )
  );
};

export default Agreement;
